<template lang="">
  <div class="px-2">
    <b-card class="w-100 d-flex rounded-lg">
      <b-row class="pb-2 w-100 d-flex justify-content-between">
        <b-col
          v-if="categories && categories.length > 0"
          md="4"
        >
          <v-select
            v-model="filter.category_id"
            :dir="'ltr'"
            :options="categories"
            class="w-100 mb-0"
            :reduce="(val) => val.id"
            placeholder="Category"
            :label="'name'"
          >
            <template v-slot:option="option">
              {{ option.name }}
            </template>
            <template #selected-option="{ name }">
              <div style="display: flex; align-items: baseline">
                {{ name }}
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <div>
          <b-button
            class="btn rounded-pill"
            variant="primary"
            @click="addTopic()"
          >
            Create experiment
          </b-button>
        </div>
      </b-row>
    </b-card>

    <center v-if="load">
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </center>

    <b-row>
      <center
        v-if="!load && items.data && items.data.length === 0"
        class="w-100 text-center mr-3"
      >
        <h3>No Data to show</h3>
      </center>
      <b-table
        v-if="!load && items.data && items.data.length > 0"
        id="drag-index"
        :items="items.data"
        :fields="fields"
        striped
        responsive
      >
        <template #cell(name)="data">
          <b-link
            v-if="data.item.id"
            :to="{ name: 'experiment_details', params: { id: data.item.id } }"
            class="text-primary font-weight-bold"
          >
            {{ data.item.name }}
          </b-link>
          <span v-else>{{ data.item.name }}</span>
        </template>

        <template #cell(id)="data">
          <feather-icon
            v-b-tooltip.hover.top="'Reorder'"
            :tooltip="'none'"
            icon="AlignJustifyIcon"
            size="18"
          />
        </template>

        <template #cell(description)="data">
          <span>
            {{ truncate(data.item.description, 80) }}
          </span>
        </template>

        <template #cell(category_name)="data">
          <b-link
            v-if="data.item.category != null && data.item.category.id"
            :to="{ name: 'show_category', params: { id: data.item.category.id } }"
            class="text-primary font-weight-bold"
          >
            {{ data.item.category.name }}
          </b-link>
          <b-link
            v-else-if="data.item.category_id"
            :to="{ name: 'show_category', params: { id: data.item.category_id } }"
            class="text-primary font-weight-bold"
          >
            {{ data.item.category_name }}
          </b-link>
          <div v-else-if="data.item.category != null">
            {{ data.item.category.name }}
          </div>
          <span v-else>
            {{ data.item.category_name }}
          </span>
        </template>

        <template #cell(sessions_count)="data">
          <b-link
            v-if="data.item.id"
            :to="{ name: 'logs', query: { experiment_id: data.item.id } }"
            class="text-primary font-weight-bold"
          >
            {{ data.item.sessions_count != null ? data.item.sessions_count : 0 }}
          </b-link>
          <span v-else>{{ data.item.sessions_count != null ? data.item.sessions_count : 0 }}</span>
        </template>

        <!-- <template #cell(current_version)="data">
                    <b-badge variant="light-success" class="font-weight-bold">
                        v{{ data.item.current_version }}
                    </b-badge>
                </template> -->
        <template #cell(current_version)="data">
          <b-badge
            variant="light-success"
            class="font-weight-bold"
          >
            v{{ data.item.current_version }}
          </b-badge>
        </template>

        <template #cell(status)="data">
          <b-badge
            :variant="data.item.status === 'active' ? 'light-success' : 'light-secondary'"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(Actions)="data">
          <div class="d-flex justify-content-start align-items-center">
            <b-link
              :to="{ name: 'experiment_details', params: { id: data.item.id } }"
              class="alert-link cutom-alert-link mr-1"
            >
              <feather-icon
                v-b-tooltip.hover.top="'View Details'"
                icon="EyeIcon"
                size="18"
              />
            </b-link>

            <!-- <b-link
                            :tooltip="'none'"
                            class="alert-link cutom-alert-link mr-1 text-info"
                            @click="viewVersions(data.item)"
                        >
                            <feather-icon icon="PackageIcon" size="18" v-b-tooltip.hover.top="'View Versions'" />
                        </b-link> -->
            <b-link
              :tooltip="'none'"
              class="alert-link cutom-alert-link mr-1 text-info"
              @click="viewVersions(data.item)"
            >
              <feather-icon
                v-b-tooltip.hover.top="'View Versions'"
                icon="PackageIcon"
                size="18"
              />
            </b-link>

            <b-link
              :tooltip="'none'"
              class="alert-link cutom-alert-link mr-1"
              :to="{ name: 'edit_experiment', params: { id: data.item.id} }"
            >
              <feather-icon
                v-b-tooltip.hover.top="'Edit'"
                :tooltip="'none'"
                icon="EditIcon"
                size="18"
              />
            </b-link>

            <b-link
              :tooltip="'none'"
              class="alert-link cutom-alert-link text-danger"
              @click="deleteExperiment(data.item.id)"
            >
              <feather-icon
                v-b-tooltip.hover.top="'Delete'"
                :tooltip="'none'"
                icon="Trash2Icon"
                size="18"
              />
            </b-link>
          </div>
        </template>
      </b-table>
      <!-- Pagination & Per Page -->
      <b-row class="mt-2 w-100 align-items-center" v-if="items && items.meta">
        <b-col md="4" class="text-light d-flex align-items-center" style="font-size: 0.95rem;">
          <span v-if="items.meta.total > 0" class="d-flex align-items-center" style="margin-left: 2px;">
            Showing 
            <b-form-select
              v-model="filter.per_page"
              :options="[10, 25, 50, 100]"
              class="custom-per-page mx-1"
              @change="onPageChange(1)"
            />
          </span>
        </b-col>
        <b-col md="4" class="d-flex justify-content-center">
          <b-pagination
            v-model="items.meta.current_page"
            :total-rows="items.meta.total"
            :per-page="items.meta.per_page"
            @change="onPageChange"
            class="mb-0"
          />
        </b-col>
        <b-col md="4"></b-col>
      </b-row>
    </b-row>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BAvatar,
  BCardText,
  BLink,
  BSpinner,
  BPagination,
  VBTooltip,
  BFormSelect,
} from 'bootstrap-vue'

export default {
  name: 'Experiments',
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
    BCardText,
    BLink,
    BSpinner,
    BPagination,
    vSelect,
    BFormSelect,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  watch: {
    '$route.params.id': function (newVal) {
      this.filter.category_id = newVal ? Number(newVal) : null
    },
    'filter.category_id': function (newVal) {
      this.$store.dispatch('experiments/list', this.filter).then(res => {

      }).catch(error => {
        if (error.response) {
          this.$swal({
            icon: 'error',
            title: `<h4>${error.response.data.error}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        }
      })
    },
  },
  computed: {
    ...mapGetters({
      items: 'experiments/items',
      categories: 'categories/lookups',
      load: 'experiments/load',
    }),
    category_id() {
      return this.$route.query.id
        ? this.$route.query.id
        : null
    },
  },
  data() {
    return {
      filter: {
        category_id: this.$route.params.id ? Number(this.$route.params.id) : null,
        per_page: 10,
      },
      trashOptions: [
        { id: 0, name: 'Active' },
        { id: 1, name: 'Inactive' },
      ],
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'description', label: 'Description' },
        { key: 'targetPackage', label: 'Target Package' },
        { key: 'category_name', label: 'Category', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'current_version', label: 'Current Version' },
        { key: 'sessions_count', label: 'Sessions Count' },
        'Actions',
      ],
    }
  },

  mounted() {
    this.init()
  },
  methods: {
    viewVersions(experiment) {
      this.$swal({
        title: 'Loading versions...',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading()
        },
      })

      this.$store.dispatch('experiments/getVersions', experiment.id)
        .then(res => {
          if (res.success && res.data && res.data.versions) {
            const { versions } = res.data

            let versionsHtml = ''
            if (versions.length > 0) {
              versionsHtml = '<div class="versions-container">'
              versions.forEach(version => {
                const date = version.release_date
                  ? new Date(version.release_date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })
                  : 'N/A'

                versionsHtml += `
                                    <div class="version-item">
                                        <div>
                                            <span class="badge badge-primary font-weight-bold">
                                                v${version.version_number}
                                            </span>
                                        </div>
                                        <div class="text-muted small">
                                            ${date}
                                        </div>
                                    </div>
                                `
              })
              versionsHtml += '</div>'
            } else {
              versionsHtml = `
                                <div class="text-center py-4 text-muted">
                                    <p class="mb-0">No versions found</p>
                                </div>
                            `
            }

            this.$swal({
              title: `<strong>Versions - ${experiment.name}</strong>`,
              html: versionsHtml,
              width: '600px',
              showCloseButton: true,
              showConfirmButton: false,
              customClass: {
                popup: 'versions-swal-popup',
                htmlContainer: 'versions-swal-content',
              },
            })
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: `<h4>${error.response.data.message || 'Failed to load versions'}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#7367f0',
              allowOutsideClick: true,
            })
          }
        })
    },

    loadData() {
      this.filter.trashed = !this.filter.trashed
      this.init()
    },

    deleteExperiment(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to delete!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel it!',
        confirmButtonColor: '#7367f0',
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('experiments/remove', id).then(_ => {
            this.init()
            this.$swal({
              icon: 'success',
              title: 'Deleted!',
              confirmButtonColor: '#7367f0',
            })
          }).catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: `<h4>${error.response.data.error ?? error.response.data.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            }
          })
        }
      })
    },

    addTopic() {
      this.$router.push({
        name: 'add_experiment',
      })
    },

    init() {
      this.$store.dispatch('categories/categoryLookups')
      this.$store.dispatch('experiments/list', this.filter).then(res => {

      }).catch(error => {
        if (error.response) {
          this.$swal({
            icon: 'error',
            title: `<h4>${error.response.data.error}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        }
      })
    },

    onPageChange(page) {
      this.$store.dispatch('experiments/list', { page, ...this.filter })
    },
    isImageLoaded(url) {
      return this.loadedImageUrls.has(url)
    },
    onImageLoad(url) {
      this.loadedImageUrls.add(url)
    },
    onImageError(url) {
      console.warn('Image failed to load:', url)
      this.loadedImageUrls.add(url)
    },
    getImageUrl(experimentId, imageUrl) {
      return imageUrl
    },
    truncate(text, length = 80) {
      if (!text) return ''
      return text.length > length ? `${text.substring(0, length)}...` : text
    },
  },
}
</script>

<style lang="scss" scoped>
table#drag-index td:nth-child(3) {
width: 5%;
white-space: normal;
word-break: break-all;
}
</style>

<style lang="scss">
.versions-swal-popup {

.swal2-close {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;

    &:focus {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }
}

.versions-container {
    max-height: 400px;
    overflow-y: auto;
    text-align: left;

    .version-item {
        padding: 1rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: background-color 0.2s;

        &:hover {
            background-color: rgba(0, 0, 0, 0.02);
        }

        &:last-child {
            border-bottom: none;
        }
        .badge{
            background: linear-gradient(90deg, #850dcc, #23c7ec);
        }
    }
}
}

</style>
